import {
  type Event,
  type EventMatchScore,
  type PaginatedResponse,
  type EventOptions,
} from '@/types';
import { makeActionCreator, makeRequestActionCreator } from '@/utils';
import {
  type FetchEventsPayload,
  type CreateEventPayload,
  type StartRealtimeIncidentsPayload,
  type DeleteEventPayload,
  type FetchEventPayload,
  type CreateIncidentPayload,
  type SetCurrentEventPayload,
  type EditIncidentPayload,
  type DeleteIncidentPayload,
  type EditEventPayload,
  type FetchEventMatchScorePayload,
  type UpdateEventMatchScorePayload,
  type DeleteEventMatchScoreEditPayload,
} from './types';
import { eventsSlice } from './slice';

const createAction = makeActionCreator(eventsSlice.name);
const createRequestAction = makeRequestActionCreator(eventsSlice.name);

export const tryFetchEvents =
  createAction<FetchEventsPayload>('tryFetchEvents');

export const fetchEvents = createRequestAction<
  FetchEventsPayload,
  PaginatedResponse<Event>
>('fetchEvents');

export const tryFetchEventOptions = createAction('tryFetchEventOptions');

export const fetchEventOptions = createRequestAction<void, EventOptions>(
  'fetchEventOptions',
);

export const fetchEvent = createRequestAction<
  FetchEventPayload,
  SetCurrentEventPayload
>('fetchEvent');

export const createEvent = createRequestAction<CreateEventPayload, Event>(
  'createEvent',
);

export const deleteEvent =
  createRequestAction<DeleteEventPayload>('deleteEvent');

export const createIncident = createRequestAction<CreateIncidentPayload, void>(
  'createIncident',
);

export const startRealtimeIncidents =
  createAction<StartRealtimeIncidentsPayload>('startRealtimeIncidents');

export const stopRealtimeIncidents = createAction('stopRealtimeIncidents');

export const editIncident = createRequestAction<EditIncidentPayload, void>(
  'editIncident',
);

export const deleteIncident = createRequestAction<DeleteIncidentPayload, void>(
  'deleteIncident',
);

export const editEvent = createRequestAction<
  EditEventPayload,
  SetCurrentEventPayload
>('editEvent');

export const fetchEventMatchScore = createRequestAction<
  FetchEventMatchScorePayload,
  EventMatchScore | null
>('fetchEventMatchScore');

export const updateEventMatchScore = createRequestAction<
  UpdateEventMatchScorePayload,
  EventMatchScore
>('updateEventMatchScore');

export const deleteEventMatchScoreEdit = createRequestAction<
  DeleteEventMatchScoreEditPayload,
  EventMatchScore
>('deleteEventMatchScoreEdit');

export const {
  setEvents,
  setPagination,
  setEventOptions,
  setCurrentEvent,
  setCurrentMatchScore,
  resetEvents,
  resetAllEventsForProperty,
  resetCurrentEvent,
  addIncident,
  updateIncident,
  removeIncident,
} = eventsSlice.actions;
